/* Packrift custom journey measurement v2. No standard ecommerce events. */
(function (w, d) {
  'use strict';
  if (w.PKMeasure) return;
  var STORE = 'pk_guide_context_v1', TTL = 30 * 60 * 1000;
  var ops = Object.create(null), seen = Object.create(null), epoch = 0, counter = 0;
  var excluded = new URLSearchParams(w.location.search).get('pk_qa') === '1' ||
    !!(w.Shopify && w.Shopify.designMode) || /bot|crawler|spider|headless|lighthouse|slurp/i.test(w.navigator.userAgent || '');
  function clear() { ops = Object.create(null); epoch++; try { w.sessionStorage.removeItem(STORE); } catch (_) {} }
  var privacyReady = false, featureRequested = false;
  function consentState() {
    if (excluded) return 'denied';
    try {
      var consent = w.Shopify.customerPrivacy.analyticsProcessingAllowed();
      if (consent === true) return 'allowed';
      return consent === false && privacyReady ? 'denied' : 'unknown';
    } catch (_) { return 'unknown'; }
  }
  function allowed() { return consentState() === 'allowed'; }
  function clearIfDenied() { if (consentState() === 'denied') clear(); }
  function token(v) { return typeof v === 'string' && /^[a-zA-Z0-9_\-]{1,100}$/.test(v) ? v : ''; }
  function path(v) {
    try { var u = new URL(v, w.location.origin); return u.origin === w.location.origin && /^\/(pages|products)\/[a-zA-Z0-9_\-]+\/?$/.test(u.pathname) ? u.pathname.replace(/\/$/, '') : ''; } catch (_) { return ''; }
  }
  function readContext() {
    if (!allowed()) return null;
    try {
      var x = JSON.parse(w.sessionStorage.getItem(STORE) || 'null');
      if (!x) return null;
      if (!Number.isFinite(x.at) || Date.now() - x.at > TTL || x.at > Date.now() || !/^\/pages\//.test(path(x.guide_path)) || !/^\/products\//.test(path(x.product_path))) { clear(); return null; }
      return { guide_path: path(x.guide_path), product_path: path(x.product_path), buyer_module: token(x.buyer_module), choice: token(x.choice), at: x.at };
    } catch (_) { clear(); return null; }
  }
  function productData(input) {
    var x = input || {}, out = {};
    ['product_id', 'variant_id'].forEach(function (k) { if (/^\d{1,20}$/.test(String(x[k] || ''))) out[k] = String(x[k]); });
    if (Number.isInteger(Number(x.quantity)) && Number(x.quantity) > 0 && Number(x.quantity) <= 1000000) out.quantity = Number(x.quantity);
    if (typeof x.free_shipping === 'boolean') out.free_shipping = x.free_shipping;
    return out;
  }
  function publish(name, data, key) {
    if (!allowed()) { clearIfDenied(); return false; }
    if (seen[key] || typeof w.gtag !== 'function') return false;
    var payload = Object.assign({ schema_version: '1', event_id: key, page_path: path(w.location.href) }, data || {});
    var context = readContext();
    if (context && context.product_path === path(w.location.href)) {
      payload.guide_path = context.guide_path; payload.buyer_module = context.buyer_module; payload.choice = context.choice;
    }
    var params = { send_to: 'G-HPMNFWG4DV', page_location: w.location.origin + path(w.location.href) };
    ['schema_version', 'event_id', 'page_path', 'guide_path', 'product_path', 'buyer_module', 'choice',
      'product_id', 'variant_id', 'quantity', 'free_shipping', 'quote_path'].forEach(function (field) {
      if (Object.prototype.hasOwnProperty.call(payload, field)) params[field] = payload[field];
    });
    try { w.gtag('event', name, params); seen[key] = true; } catch (_) { return false; }
    // Retain Shopify custom-event visibility. Its former GA4 bridge must be disconnected.
    try {
      if (w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        var result = w.Shopify.analytics.publish(name, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (_) {}
    return true;
  }
  function id(prefix) { return prefix + '_' + Date.now().toString(36) + '_' + (++counter).toString(36) + '_' + Math.random().toString(36).slice(2, 10); }
  function begin(kind, data) {
    if (!allowed() || typeof w.gtag !== 'function' || (kind !== 'freight' && kind !== 'add')) return null;
    var key = id(kind); ops[key] = { kind: kind, epoch: epoch, data: productData(data) };
    if (kind === 'freight') publish('pk_freight_start', ops[key].data, key + '_start');
    return key;
  }
  function finish(kind, key, data) {
    var op = key && ops[key];
    if (!op) return false;
    delete ops[key];
    if (!allowed() || op.epoch !== epoch) { clearIfDenied(); return false; }
    if ((op.kind === 'freight' && kind !== 'freight_success' && kind !== 'freight_error') || (op.kind === 'add' && kind !== 'add_success')) return false;
    return publish('pk_' + kind, Object.assign({}, op.data, productData(data)), key + '_' + kind);
  }
  function page() {
    if (!allowed()) return;
    var current = path(w.location.href);
    if (/^\/pages\//.test(current) && d.querySelector('[data-buyer-module]')) publish('pk_guide_view', { guide_path: current }, 'view_' + current);
    var context = readContext();
    if (context && context.product_path === current) publish('pk_pdp_from_guide', { product_path: current }, 'pdp_' + current);
  }
  function click(e) {
    if (!allowed() || typeof w.gtag !== 'function') return;
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    var target = path(link.href), current = path(w.location.href), module = link.closest('[data-buyer-module]');
    if (module && /^\/pages\//.test(current) && /^\/products\//.test(target)) {
      var choiceNode = link.closest('[data-choice]');
      var data = { guide_path: current, product_path: target, buyer_module: token(module.getAttribute('data-buyer-module')), choice: token(choiceNode && choiceNode.getAttribute('data-choice')) };
      try { w.sessionStorage.setItem(STORE, JSON.stringify(Object.assign({ at: Date.now() }, data))); } catch (_) {}
      publish('pk_guide_select', data, id('select'));
    }
    if (target === '/pages/bulk-quote') publish('pk_quote_click', { quote_path: target }, id('quote'));
  }
  w.PKMeasure = { version: '2', begin: begin, finish: finish };
  if (excluded) { clear(); return; }
  d.addEventListener('click', click);
  d.addEventListener('visitorConsentCollected', function () {
    // An explicit consent event is authoritative; never retain context on revocation.
    privacyReady = true;
    if (!allowed()) clear(); else page();
  });
  function requestConsentAPI() {
    var shopify = w.Shopify;
    if (!featureRequested && shopify && typeof shopify.loadFeatures === 'function') {
      featureRequested = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) { privacyReady = true; boot(); } else featureRequested = false;
        });
      } catch (_) { featureRequested = false; /* Retry only through the bounded boot checks. */ }
    } else if (!featureRequested && shopify && shopify.customerPrivacy &&
      typeof shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
      // Platforms exposing the ready API without a feature loader still work.
      privacyReady = true;
    }
  }
  function boot() {
    requestConsentAPI();
    var state = consentState();
    if (state === 'allowed') page();
    else if (state === 'denied') clear();
    // Unknown/loading is not a revocation. Never read or delete saved context here.
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  if (typeof w.addEventListener === 'function') w.addEventListener('load', boot, { once: true });
  if (typeof w.setTimeout === 'function') [250, 1000, 3000].forEach(function (delay) { w.setTimeout(boot, delay); });
  // Always request the supported callback, including when a privacy object exists.
  requestConsentAPI();
})(window, document);
